var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow"
        }
      ],
      staticClass: "mku-backtop",
      style: _vm.backtopStyle,
      on: { click: _vm.backToTop }
    },
    [_vm._t("default", [_vm._m(0)])],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mku-backtop__wrap" }, [
      _c("i", { staticClass: "mku-icon mku-icon-backtop mku-backtop__icon" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }